import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

import LinkContainer from './LinkContainer';

/* eslint-disable react/prefer-stateless-function */
export default class Header extends Component {
  constructor(props) {
    super(props);

    this.modalButton = React.createRef();
    this.profileButton = React.createRef();

    this.state = {
      modalOpen: false,
    };
  }

  logout = (e) => {
    e.preventDefault();

    /* eslint-disable-next-line */
    const shouldLogout = confirm('Are you sure you want to logout?');

    if (shouldLogout) {
      this.toggleModal();
      const endpoint = '/logout';
      axios.post(endpoint).then(() => {
        /* eslint-disable-next-line */
        window.location.href = '/';
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  toggleModal = (e) => {
    if (e) e.preventDefault();

    const { modalOpen } = this.state;

    if (!modalOpen) {
      /* eslint-disable-next-line */
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      /* eslint-disable-next-line */
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    /* eslint-disable-next-line */
    this.setState({ modalOpen: !this.state.modalOpen });
  }

  handleOutsideClick = (e) => {
    const insideModalButton = this.modalButton.current.contains(e.target);
    const isProfileButton = this.profileButton.current.contains(e.target);
    if (insideModalButton && !isProfileButton) return;

    this.toggleModal();
  }

  render() {
    const { modalOpen } = this.state;
    const {
      hideAuth,
    } = this.props;

    return (
      <NavContainer>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/images/blueshyft-logo.png" alt="logo" style={{ width: 120 }} />
        </div>
        {!hideAuth ? (
          <LinksContainer>
            <LinkContainer exact to="/" label="DASHBOARD" />
            <LinkContainer to="/upload" label="UPLOAD" />
            <LinkContainer to="/view-spec" label="VIEW SPEC" />
            <div>
              <LinkContainer
                label={<img src="/images/avatar.png" alt="logo" style={{ width: 30, height: 30, marginTop: 1 }} />}
                onClick={this.toggleModal}
              />
              {modalOpen ? (
                <Modal ref={this.modalButton}>
                  <ModalTriangle />
                  <ModalButton ref={this.profileButton}>
                    <NavLink to="/profile" style={{ textDecoration: 'none', color: '#384076' }}>PROFILE</NavLink>
                  </ModalButton>
                  <div style={{ height: 1, backgroundColor: '#e1e4ee' }} />
                  <ModalButton onClick={this.logout}>SIGN OUT</ModalButton>
                </Modal>
              ) : null}
            </div>
          </LinksContainer>
        ) : null}
      </NavContainer>
    );
  }
}

Header.propTypes = {
  hideAuth: PropTypes.bool,
};

Header.defaultProps = {
  hideAuth: false,
};

const ModalTriangle = styled.div`
  position: absolute;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
  width: 0px;
  height: 0px;
  margin-Top: -15px;
  margin-left: 35px;
`;

const Modal = styled.div`
  position: absolute;
  background-color: white;
  border-radius: 5px;
  padding: 5px;
  box-shadow: 0px 2px 15px #0000004a;
  font-family: 'Karla', sans-serif;
  margin-top: 15px;
  margin-left: 10px;
`;

const ModalButton = styled.div`
  text-align: center;
  color: #384076;
  padding: 10px;
  cursor: pointer;
`;

const NavContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  padding-left: 50px;
  padding-right: 50px;
  background-color: #5d81ec;
  // <<<<<<< HEAD //   margin-bottom: 25px;
  //   min-height: 46px;
  // =======
  margin-bottom: 80px;
  // >>>>>>> 4473bea8c15943f2018940a9feaf8b14c078d6eb
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  // width: 35%; 
  justify-content: space-between;
`;



// WEBPACK FOOTER //
// ./client/components/Header.js